'use strict';

angular.module('shiftTraderApp')
  .factory('UsersPositions', function ($http, ServerUrls, $q) {

    var UsersPositions = {};

    UsersPositions.create = function(data) {
      return $http.post(ServerUrls.current.railsApi + 'users_positions/', data)
        .then(function(response) {
          //console.log('users_positions response');
          //console.log(response);
          return response.data;
        }, function(response) {
          return $q.reject(response);
        });
    };

    //IE8 doesn't like anything with a property name of 'delete'
    UsersPositions['delete'] = function(data) {
      // IE8 doesn't like $http.delete name
      return $http['delete'](ServerUrls.current.railsApi + 'users_positions/' + data.id)
        .then(function(response) {
          //console.log('users_positions deleted');
          //console.log(response);
          return response.data;
        }, function(response) {
          return $q.reject(response);
        });
    };

    UsersPositions.update = function(data) {
      return $http.put(ServerUrls.current.railsApi + 'users_positions/' + data.id + '.json', data)
        .then(function(response) {
          //console.log('users_positions updated');
          //console.log(response);
          return response.data;
        }, function(response) {
          return $q.reject(response);
        });
    };

    // Public API here
    return UsersPositions;
  });
